import { render, staticRenderFns } from "./combination2.vue?vue&type=template&id=c4dddf40&scoped=true&"
import script from "./combination2.vue?vue&type=script&lang=js&"
export * from "./combination2.vue?vue&type=script&lang=js&"
import style0 from "./combination2.vue?vue&type=style&index=0&id=c4dddf40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dddf40",
  null
  
)

export default component.exports